// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditions_container__3dLz8"};